export const UNDEFINED_CLEANUP_STAGE = 'UNDEFINED_CLEANUP_STAGE';
export const RUNNING_CLEANUP_STAGE = 'RUNNING_CLEANUP_STAGE';
export const ACCESSIBLE_CLEANUP_STAGE = 'ACCESSIBLE_CLEANUP_STAGE';
